import { render } from "./BetsElement.vue?vue&type=template&id=be85e0ac&scoped=true"
import script from "./BetsElement.vue?vue&type=script&lang=js"
export * from "./BetsElement.vue?vue&type=script&lang=js"

import "./BetsElement.vue?vue&type=style&index=0&id=be85e0ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be85e0ac"]])

export default __exports__